import * as React from 'react';

function Canoeing(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.835 4.146c1.09 1.092 1.432 2.575.9 3.572l7.192 7.643c.97-.287 2.235.092 3.196 1.054 1.266 1.265 1.523 3.062.573 4.012-.95.95-2.746.693-4.013-.573-1.035-1.037-1.396-2.428-.973-3.42L7.416 8.684c-.943.196-2.116-.193-3.02-1.097C3.13 6.32 2.873 4.523 3.823 3.573c.95-.95 2.746-.693 4.013.573h-.001zM2.709 8.405a22.804 22.804 0 004.931 1.723l4.483 4.76c-2.406.028-4.896-.28-7.123-1.01-2.972-.971-3.736-2.795-2.291-5.473zm18.328 0c.992 2.826.227 4.65-2.291 5.474-.778.254-1.63.466-2.53.629l-3.693-3.924c2.838-.096 5.676-.823 8.514-2.179z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Canoeing;
